import React, { useEffect, useState } from "react";
import Layout from "../components/layout";
import axios from "axios";
import "../index.css";
import { useSelector } from "react-redux";

const Dashboard = () => {
  const [history, setHistory] = useState([]);

  const [patientNumber, setPatientNumber] = useState("");
  const [societeNumber, setSocieteNumber] = useState("");
  const isAdmin = useSelector((state) => state.user.user?.type === "Admin");
  const isUser = useSelector((state) => state.user.user?.type === "User");
  const isAfl = useSelector((state) => state.user.user?.type === "Afl");

  useEffect(() => {
    const getHistory = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/history/other`,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
            method: "POST",
          }
        );

        const historyData = await response.json();

        if (historyData.success) {
          console.log("historyData: ", historyData);
          setHistory(historyData.Result); // Ensure to set the actual array
        }
      } catch (error) {
        console.error("Error fetching history:", error);
      }
    };

    getHistory();
  }, []);

  useEffect(() => {
    const getPatientsAndSociete = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/total-patients-societe`,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
            method: "GET",
          }
        );

        const patientAndSociete = await response.json();

        if (patientAndSociete.success) {
          console.log("historyData: ", patientAndSociete);
          setPatientNumber(patientAndSociete.Result.patientData); // Ensure to set the actual array
          setSocieteNumber(patientAndSociete.Result.societeData); // Ensure to set the actual array
        }
      } catch (error) {
        console.error("Error fetching history:", error);
      }
    };

    getPatientsAndSociete();
  }, []);

  const scanHistory = history.filter(
    (e) => e.category && e.category.includes("Scan")
  );

  return (
    <Layout>
      <div className="px-5 mt-3">
        <div className="d-flex justify-content-center">
          <h3 className="page-title">Tableau de bord</h3>
        </div>
        <div className="mt-3">
          {(isAdmin || isUser) && (
            <div className="d-flex justify-content-center mt-10 card-container">
              <div className="card-dashboard patient-card">
                <p className="card-title-dashboard">
                  Total patients : {patientNumber}
                </p>
              </div>

              <div className="card-dashboard societe-card">
                <p className="card-title-dashboard">
                  Total société affiliée : {societeNumber}
                </p>
              </div>
            </div>
          )}
          {isAfl && (
            <div className="d-flex justify-content-center mt-10 card-container">
              {/* <div className="card-dashboard patient-card"> */}
              <div className="card-dashboard patient-card">
                <p className="card-title-dashboard">
                  Total employés affiliés : {patientNumber}
                </p>
              </div>
              {/* </div> */}
            </div>
          )}

          <table className="table mt-3">
            <thead>
              <tr>
                <th className="category">Catégorie</th>
                <th className="category">Noms</th>
                <th className="category">Heure d'entrée</th>
                <th className="category">Heure de sortie</th>
                <th className="category">Société</th>
                <th className="category">Adresse</th>
                <th className="category">Utilisateur</th>
              </tr>
            </thead>
            <tbody>
              {scanHistory.map((e, index) => (
                <tr key={index}>
                  <td>{e.category.includes("Scan") ? "Scan" : e.category}</td>
                  <td>{e.noms ? e.noms : "N/A"}</td>
                  <td>{new Date(e.entry_time).toLocaleString()}</td>

                  <td>
                    {e.category && e.category.includes("Scan")
                      ? e.exit_time
                        ? new Date(e.exit_time).toLocaleString()
                        : "N/A"
                      : e.description}
                  </td>
                  <td>
                    {e.category && e.category.includes("Scan")
                      ? e.description
                      : e.societe}
                  </td>
                  <td>{e.addresse}</td>
                  <td>{e.prise_en_charge_noms}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;
